import { createSelector } from '@ngrx/store';
import { getCustomHubState } from '../feature.selector';
import { CustomHubState } from '../state';

const getLastDealsProductsState = createSelector(
  getCustomHubState,
  (state: CustomHubState) => state && state.lastDealsProductsState
);

export const getLastDealsProducts = createSelector(
  getLastDealsProductsState,
  state => state && state.payload
);
